import axios from 'axios';
import { useEffect, useState } from 'react';
import { getToken } from '../utils';

export const Data = () => {
  const [localData, setLocalData] = useState([]);
  const [foreignData, setForeignData] = useState([]);
  const { token: userToken } = getToken();

  useEffect(() => {
    const localAccount = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/local-accounts`,
          {
            headers: { Authorization: `Bearer ${userToken}` },
          }
        );
        setLocalData(response.data);
      } catch (error) {
        console.log(error);
      }
    };
    localAccount();
  }, [userToken]);

  useEffect(() => {
    const foriegnAccount = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/cx-accounts`,
          {
            headers: { Authorization: `Bearer ${userToken}` },
          }
        );
        setForeignData(response.data);
      } catch (error) {
        console.log(error, 'error now');
      }
    };
    foriegnAccount();
  }, [userToken]);

  const foreignAccountData = foreignData?.map((data) => ({
    name: data?.account_name,
    iban: data?.iban_number,
    swiftcode: data?.swift_code,
    bankname: data?.bank_name,
    bankopeningbranch: data?.bank_address,
    currency: (
      <div className='flex flex-row gap-2 items-center'>
        <img
          src={data?.currency?.country?.flag}
          alt={data?.currency?.name}
          className='w-5 h-[13px]'
        />
        <p>
          {data?.currency?.name} ({data?.currency?.symbol})
        </p>
      </div>
    ),
    country: (
      <div className='flex flex-row gap-2 items-center'>
        <img
          src={data?.country?.flag}
          alt={data?.country?.name}
          className='w-5 h-[13px]'
        />
        <p>{data?.country?.name} </p>
      </div>
    ),
  }));

  const localAccountData = localData?.map((data) => ({
    name: data?.account_name,
    accountnumber: data?.account_number,
    bankname: data?.bank_name,
    currency: (
      <div className='flex flex-row gap-2 items-center'>
        <img
          src={data?.currency?.country?.flag}
          alt={data?.currency?.name}
          className='w-5 h-[13px]'
        />
        <p>
          {data?.currency?.name} ({data?.currency?.symbol})
        </p>
      </div>
    ),
    country: (
      <div className='flex flex-row gap-2 items-start '>
        <img
          src={data?.country?.flag}
          alt={data?.country?.name}
          className='w-5 h-[13px]'
        />
        <p>{data?.country?.name} </p>
      </div>
    ),
  }));

  return { localAccountData, foreignAccountData, localData, foreignData };
};
